module.exports = __webpack_public_path__ + "img/hero-image-top.df54b5e4.png";